import { Controller } from '@hotwired/stimulus'
import * as analytics from '../../libs/analytics'

export default class extends Controller {
  // The rail button carries the click, so a tab that closes the drawer (clicking
  // the already-open tab) would otherwise count as another open.
  panelOpened({ params, currentTarget }) {
    if (currentTarget.dataset.active === 'true') return

    analytics.capture('calendar_drawer_panel_opened', { panel: params.panel })
  }

  actionClicked({ params }) {
    analytics.capture('calendar_drawer_action_clicked', { panel: params.panel })
  }
}
